import { getContraWebAppBaseUrl } from './getContraWebAppBaseUrl.js';

export const getContraUrl = (pathname: string = '') => {
  const baseUrl = getContraWebAppBaseUrl();
  if (!pathname) return baseUrl;

  const resolvedPathname = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${baseUrl}${resolvedPathname}`;
};
